import { Method, Format } from "./interface"

// 对api进行统一管理
// api地址为http://172.31.210.21:21610/swagger/index.html

const requestkind = {
    Authentication: {
        GetUserInfo: {
            url: "Authentication/GetUserInfo",
            method: Method.GET,
            format: Format.json
        },
        UpdateUserInfo: {
            url: "Authentication/UpdateUserInfo",
            method: Method.POST,
            format: Format.json
        }
    },
    Credit: {
        GetCreditSummary: {
            url: "Credit/GetCreditSummary",
            method: Method.GET,
            format: Format.json
        },
        GetGuaranteeSummary: {
            url: "Credit/GetGuaranteeSummary",
            method: Method.GET,
            format: Format.json
        },
        GetAgreementInfo: {
            url: "Credit/GetAgreementInfo",
            method: Method.GET,
            format: Format.json
        },
        GetPartnerOverdueStatus: {
            url: "Credit/GetPartnerOverdueStatus",
            method: Method.GET,
            format: Format.json
        },
        GetPartnerOverdueDetail: {
            url: "Credit/GetPartnerOverdueDetail",
            method: Method.GET,
            format: Format.json
        }
    },
    CreditApply: {
        Search: {
            url: "CreditApply/Search",
            method: Method.POST,
            format: Format.json
        },
        ApplyVerify: {
            url: "CreditApply/ApplyVerify",
            method: Method.POST,
            format: Format.form
        },
        Apply: {
            url: "CreditApply/Apply",
            method: Method.POST,
            format: Format.form
        },
        Delete: {
            url: "CreditApply/Delete",
            method: Method.POST,
            format: Format.json
        },
        Cancel: {
            url: "CreditApply/Cancel",
            method: Method.POST,
            format: Format.json
        },
        Detail: {
            url: "CreditApply/Detail",
            method: Method.GET,
            format: Format.json
        }
    },
    GuaranteeAdd: {
        Search: {
            url: "GuaranteeAdd/Search",
            method: Method.POST,
            format: Format.json
        },
        Apply: {
            url: "GuaranteeAdd/Apply",
            method: Method.POST,
            format: Format.form
        },
        Delete: {
            url: "GuaranteeAdd/Delete",
            method: Method.POST,
            format: Format.json
        },
        Cancel: {
            url: "GuaranteeAdd/Cancel",
            method: Method.POST,
            format: Format.json
        },
        Detail: {
            url: "GuaranteeAdd/Detail",
            method: Method.GET,
            format: Format.json
        }
    },
    GuaranteeWithdraw: {
        Search: {
            url: "GuaranteeWithdraw/Search",
            method: Method.POST,
            format: Format.json
        },
        Apply: {
            url: "GuaranteeWithdraw/Apply",
            method: Method.POST,
            format: Format.form
        },
        Delete: {
            url: "GuaranteeWithdraw/Delete",
            method: Method.POST,
            format: Format.json
        },
        Cancel: {
            url: "GuaranteeWithdraw/Cancel",
            method: Method.POST,
            format: Format.json
        },
        Detail: {
            url: "GuaranteeWithdraw/Detail",
            method: Method.GET,
            format: Format.json
        }
    },
    Partner: {
        CurrentParterInfo: {
            url: "Partner/CurrentParterInfo",
            method: Method.GET,
            format: Format.json
        }
    },
    File: {
        DownloadStaticFile: {
            url: "File/DownloadStaticFile",
            method: Method.GET,
            format: Format.blob
        },
        downloadUploadedFile: {
            url: "File/Download",
            method: Method.GET,
            format: Format.blob
        }
    },
    GuaranteeStatement: {
        SearchAdditionGuarantee: {
            url: "GuaranteeStatement/SearchAdditionGuarantee",
            method: Method.POST,
            format: Format.json
        }
    }
}
export default requestkind